export interface EnvironmentConfig {
  REACT_APP_BACKEND_API_URL: string;
  REACT_APP_BACKEND_API_URL_DEMO?: string; // Demo mode backend URL (if set, demo mode button is shown)
  REACT_APP_MSAL_CLIENT_ID: string;
  REACT_APP_MSAL_TENANT_ID: string;
  REACT_APP_MSAL_REDIRECT_URI?: string; // Now optional since we determine it dynamically
  REACT_APP_AZURE_AUTHORITY?: string;
  REACT_APP_BACKEND_API_URL_SCOPE?: string;
  REACT_APP_CHAT_DEBUG?: string;
  REACT_APP_API_DEBUG?: string;
  // OIDC Configuration
  REACT_APP_OIDC_ENABLED?: string; // Feature flag: 'true' to enable OIDC
  REACT_APP_OIDC_CLIENT_ID?: string; // OIDC client ID (default: '6')
  NODE_ENV: 'development' | 'production' | 'test';
}

declare global {
  namespace NodeJS {
    interface ProcessEnv extends EnvironmentConfig {}
  }
}

export const validateEnvironment = (): void => {
  const required = [
    'REACT_APP_BACKEND_API_URL',
    'REACT_APP_MSAL_CLIENT_ID',
    'REACT_APP_MSAL_TENANT_ID'
    // REACT_APP_MSAL_REDIRECT_URI is now optional since we set it dynamically
  ];

  const missing = required.filter(key => !process.env[key]);
  
  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
};
